import { computedFrom, customElement } from 'aurelia-framework';
import { bindable } from 'aurelia-typed-observable-plugin';
import { SystemError } from 'framework/error_handling/system-error';
import { DeviationDetailType } from 'model/business-enums';
import { DeviationDetailBase } from 'model/forms/deviation-request';

@customElement('deviation-detail-panel')
export class DeviationDetailPanelCustomElement {
  @bindable model: DeviationDetailBase;
  @bindable disabled: boolean;

  @computedFrom('model')
  get deviationDetailWidget(): string {
    switch (this.model.detailType) {
      case DeviationDetailType.Airline:
        return "airline-deviation-detail";
      case DeviationDetailType.ClassOfTravel:
        return "class-of-travel-deviation-detail";
      case DeviationDetailType.Hotel:
        return "hotel-deviation-detail";
      case DeviationDetailType.AirlineExtended:
        return "airline-extended-deviation-detail";
      default:
        throw new SystemError(`Deviation detail type ${this.model.detailType} is not supported`, "Not supported");
    }
  }

  @computedFrom('model')
  get sectionHeading(): string {
    switch (this.model.detailType) {
      case DeviationDetailType.Airline:
        return "Airline Details";
      case DeviationDetailType.ClassOfTravel:
        return "Class of Travel Details";
      case DeviationDetailType.Hotel:
        return "Hotel Details";
      case DeviationDetailType.AirlineExtended:
        return "Airline and Flight Details";
      default:
        return "Details";
    }
  }

  @computedFrom('model')
  get sectionIntro(): string {
    const introText = "Please provide us with details of"
    switch (this.model.detailType) {
      case DeviationDetailType.Airline:
        return `${introText} non-approved Airline.`;
      case DeviationDetailType.ClassOfTravel:
        return `${introText} non-approved Class of Travel.`;
      case DeviationDetailType.Hotel:
        return `${introText} non-approved Hotel.`;
      case DeviationDetailType.AirlineExtended:
        return `${introText} a flight with non-approved Airline.`;
      default:
        return "Details";
    }
  }
}
